import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioGroup, Radio } from '@zocdoc/components/src/radio';
import CollapsibleSection from '@zocdoc/components/src/CollapsibleSection';
import { injectIntl, defineMessages } from 'react-intl';

export const LOCALIZED_STRINGS = defineMessages({
    Title: {
        id: 'Components.RefineSearch.VisitReasonsPanel.Title',
        defaultMessage: 'reason for visit',
    },
});

class VisitReasonsPanel extends Component {
    static propTypes = {
        onChangeCallback: PropTypes.func.isRequired,
        procedureId: PropTypes.string.isRequired,
        specialtyId: PropTypes.string.isRequired,
        visitReasons: PropTypes.array.isRequired,
    };

    // block updates to the component while proceduresBySpecialty
    // are loading to avoid visual flash
    shouldComponentUpdate(nextProps) {
        return nextProps.visitReasons.length;
    }

    render() {
        const {
            defaultOpen,
            intl,
            onChangeCallback,
            procedureId,
            visitReasons,
        } = this.props;

        return (
            <CollapsibleSection
                data-test="search-visit-reasons-panel"
                defaultOpen={defaultOpen}
                headerText={intl.formatMessage(LOCALIZED_STRINGS.Title)}
            >
                {this.renderRadios({
                    onChangeCallback,
                    procedureId,
                    visitReasons,
                })}
            </CollapsibleSection>
        );
    }

    renderRadios() {
        const {
            onChangeCallback,
            procedureId,
            visitReasons,
        } = this.props;

        if (!visitReasons || !visitReasons.length) {
            return;
        }

        return (
            <RadioGroup
                flush
                name="procedureId"
                onChangeCallback={update => onChangeCallback({ procedureId: update })}
                renderWithoutBox
                selectedValue={procedureId}
            >
                {visitReasons.map(l => (
                    <Radio
                        key={l.id}
                        data-test={l.name}
                        text={l.name}
                        value={l.id}
                    />
                ))}
            </RadioGroup>
        );
    }
}

export default injectIntl(VisitReasonsPanel);
